/**
 * Mobile drawer — slide-in side menu for small screens.
 *
 * Markup expected:
 *   <button data-prlab-drawer-toggle aria-controls="prlab-mobile-drawer" aria-expanded="false">
 *   <aside data-prlab-drawer id="prlab-mobile-drawer" aria-hidden="true">
 *     <div data-prlab-drawer-close></div>
 *     <div class="mobile-drawer__panel">...</div>
 *   </aside>
 *
 * Toggle adds `.is-open` to the drawer + `.is-drawer-open` to <body> (CSS
 * handles overlay fade and panel slide). Closing on overlay click, X button,
 * ESC key, or following any anchor within the drawer.
 */

const ROOT_CLASS = 'is-drawer-open';

let toggleBtn  = null;
let drawer     = null;
let lastFocus  = null;

function isOpen() {
	return drawer && drawer.classList.contains('is-open');
}

function open() {
	if (!drawer || isOpen()) return;
	lastFocus = document.activeElement;

	drawer.classList.add('is-open');
	drawer.setAttribute('aria-hidden', 'false');
	document.body.classList.add(ROOT_CLASS);
	if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');

	// Focus first interactive element inside panel.
	const panel = drawer.querySelector('.mobile-drawer__panel');
	const focusable = panel && panel.querySelector('button, a[href]');
	if (focusable) {
		// Slight delay so the panel finishes sliding before focus jump.
		setTimeout(() => focusable.focus(), 320);
	}
}

function close() {
	if (!drawer || !isOpen()) return;

	drawer.classList.remove('is-open');
	drawer.setAttribute('aria-hidden', 'true');
	document.body.classList.remove(ROOT_CLASS);
	if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');

	if (lastFocus && typeof lastFocus.focus === 'function') {
		lastFocus.focus();
	}
}

function onKeydown(e) {
	if (e.key === 'Escape' && isOpen()) {
		e.preventDefault();
		close();
	}
}

export function initMobileDrawer() {
	toggleBtn = document.querySelector('[data-prlab-drawer-toggle]');
	drawer    = document.querySelector('[data-prlab-drawer]');
	if (!toggleBtn || !drawer) return;

	toggleBtn.addEventListener('click', (e) => {
		e.preventDefault();
		isOpen() ? close() : open();
	});

	// Close on overlay or close-button click.
	drawer.addEventListener('click', (e) => {
		if (e.target.closest('[data-prlab-drawer-close]')) {
			e.preventDefault();
			close();
		}
	});

	// Close on any in-drawer link click (so the new page loads with drawer closed).
	drawer.addEventListener('click', (e) => {
		const link = e.target.closest('a[href]');
		if (link && !link.closest('[data-prlab-drawer-close]')) {
			// Don't intercept the click — just close the drawer state.
			close();
		}
	});

	document.addEventListener('keydown', onKeydown);

	// Close drawer if viewport widens past mobile breakpoint.
	const mq = window.matchMedia('(min-width: 880px)');
	if (mq.addEventListener) {
		mq.addEventListener('change', (ev) => {
			if (ev.matches && isOpen()) close();
		});
	}
}
